import PropTypes from 'prop-types';
import React from 'react';

import Confirm from 'common/components/Confirm';

const RideRequestErrorDialog = ({message, onConfirm, title}) => (
  <Confirm
    confirmButtonText="Okay"
    hideCancel
    message={<div data-id="ride-request-error">{message}</div>}
    onConfirm={onConfirm}
    open
    title={title || 'Oops!'}
  />
);

RideRequestErrorDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default RideRequestErrorDialog;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideRequestErrorDialog/RideRequestErrorDialog.js